exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pic-size {\r\n    width:120px;\r\n    height:120px;\r\n    margin: 10px 0 0 0;\r\n  }\r\n  .dl-size{\r\n    width: 200px;\r\n    height: 120px;\r\n    margin: 10px 0 0 0;\r\n  }\r\n\r\n  .dl-size + .btn-icon, .pic-size + .btn-icon{\r\n    background: #834495 !important;\r\n    width: 30px;\r\n    height: 30px;\r\n    margin: 0 10px !important;\r\n    color: #fff !important;\r\n  }\r\n  .dl-size + .btn-icon i, .pic-size + .btn-icon i{ \r\n    line-height: 2 !important;\r\n    color: rgba(255, 255, 255, 0.8) !important;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/drivers/manage-driver/manage-driver.component.css
// module id = ../../../../../src/app/users/drivers/manage-driver/manage-driver.component.css
// module chunks = main